import { createApi } from "@reduxjs/toolkit/query/react";
import { VERIFICATION_CODE } from "../../configs";
import { VerificationTokenType } from "../../types";
import { createBaseQuery } from "../helpers/baseQueryHelper";

export type VerifyRequest = {
  email: string;
  token: string;
  type: VerificationTokenType;
};

export type GenerateRequest = Omit<VerifyRequest, "token">;

export enum AccountState {
  PENDING_EMAIL_VERIFICATION = "PENDING_EMAIL_VERIFICATION",
  PENDING_PHONE_VERIFICATION = "PENDING_PHONE_VERIFICATION",
  ACTIVE = "ACTIVE",
}

export type VerificationCodeResponse = {
  success: boolean;
};

const verificationCodeApi = createApi({
  reducerPath: VERIFICATION_CODE.reducerPath,
  baseQuery: createBaseQuery(VERIFICATION_CODE.baseUrl),
  tagTypes: VERIFICATION_CODE.tagTypes,
  endpoints(builder) {
    return {
      verify: builder.mutation<VerificationCodeResponse, VerifyRequest>({
        query: (data) => ({
          url: "/verify",
          method: "POST",
          body: data,
        }),
      }),
      generate: builder.mutation<VerificationCodeResponse, GenerateRequest>({
        query: (data) => ({
          url: "/generate",
          method: "POST",
          body: data,
        }),
      }),
    };
  },
});

export const { useVerifyMutation, useGenerateMutation } = verificationCodeApi;

export { verificationCodeApi };
